// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"f4f60de6","453":"68693753","529":"0c69be8a"}[chunkId] + ".chunk.js";
};